var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPIuXpGcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#32239B",
    d: "M8.347 54.469H4.1c-2.264 0-4.1-1.835-4.1-4.1V6.662c0-2.235 1.813-4.047 4.048-4.047h45.02c2.236 0 4.049 1.812 4.049 4.047V50.37c0 2.264-1.836 4.099-4.1 4.099H17.375M12.526 54.471L12.519 54.469M6.059 4.717L6.059 0M12.892 4.717L12.892 0M19.725 4.717L19.725 0M26.557 4.717L26.557 0M33.39 4.717L33.39 0M40.223 4.717L40.223 0M47.056 4.717L47.056 0M52.959 13.402L.157 13.402",
    transform: "translate(-521.000000, -170.000000) translate(522.000000, 171.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#EFEDF7",
    d: "M43.761 25.179H9.355c-1.82 0-3.294-1.476-3.294-3.295v-.001c0-1.82 1.475-3.295 3.295-3.295H43.76c1.82 0 3.295 1.476 3.295 3.295h0c0 1.82-1.475 3.296-3.294 3.296z",
    transform: "translate(-521.000000, -170.000000) translate(522.000000, 171.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#22BB76",
    d: "M43.761 36.66H9.355c-1.82 0-3.294-1.476-3.294-3.295s1.475-3.295 3.295-3.295H43.76c1.82 0 3.295 1.476 3.295 3.295 0 1.82-1.475 3.295-3.294 3.295z",
    transform: "translate(-521.000000, -170.000000) translate(522.000000, 171.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#EFEDF7",
    d: "M43.761 48.143H9.355c-1.82 0-3.294-1.476-3.294-3.295 0-1.82 1.475-3.295 3.295-3.295H43.76c1.82 0 3.295 1.475 3.295 3.295 0 1.819-1.475 3.295-3.294 3.295z",
    transform: "translate(-521.000000, -170.000000) translate(522.000000, 171.000000)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPIuXpGcn);
export default __webpack_public_path__ + "static/media/pIUXpGcn.f30b5ec2d1be1f23a30c20c2a44e1b65.svg";
export { ForwardRef as ReactComponent };